import React from 'react';
import { Link } from 'react-router-dom';

function ReturnPolicy() {
  return (
    <>
      <section class="contact-info-area pt-100 pb-70">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-sm-12">
              <h2>Return Policy</h2>

              <div className="legalSection">
                <ul>
                  <li><i class="flaticon-check"></i>Returns or exchanges allowed within 7 day of purchase.</li>
                  <li><i class="flaticon-check"></i>Items must be unused and in original packaging.</li>
                  <li><i class="flaticon-check"></i>Sale items may not be eligible for return.</li>
                  <li><i class="flaticon-check"></i>Certain categories may be exempt from return.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ReturnPolicy;
